import React, {Component} from 'react'
import {Image, Button, Tooltip, OverlayTrigger, ButtonToolbar, Badge} from 'react-bootstrap'
import Cropper from 'react-cropper'
import {Actions} from 'jumpstate'
import showToastr from '../../utils/showToastr'
import {FaMagnet, MdAddAPhoto, MdMouse, MdPanTool, MdFileUpload, MdClear} from '../Common/ReactIcons/icons'

import 'cropperjs/dist/cropper.css'

const avatar = `${window.location.protocol}//${window.location.host}/default_avatar.png`

class UserAvatar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: props.user,
      src: '',
      showCropper: false,
      showImage: true,
      progress: false,
      request: null,
      showHelp: true
    }
    this.showCropper = this.showCropper.bind(this)
    this.startUpload = this.startUpload.bind(this)
    this.loading = this.loading.bind(this)
    this.cancelUpload = this.cancelUpload.bind(this)
    this.requestSetter = this.requestSetter.bind(this)
    this.cropMove = this.cropMove.bind(this)
    this.cropEnd = this.cropEnd.bind(this)
  }

  requestSetter (r) {
    this.setState({request: r})
  }

  cancelUpload () {
    if (this.state.progress) {
      this.state.request.cancel()
    }
    this.setState({showCropper: false})
  }

  showCropper (event) {
    event.preventDefault()
    let files
    if (event.dataTransfer) {
      files = event.dataTransfer.files
    } else if (event.target) {
      files = event.target.files
    }

    const reader = new window.FileReader()
    reader.onload = () => {
      this.setState({ src: reader.result, showCropper: true })
    }
    reader.readAsDataURL(files[0])
  }

  loading (progressEvent) {
    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    this.setState({progress: percentCompleted})
  }

  startUpload () {
    let data = new window.FormData()
    const {x, y, width, height} = this.refs.cropper.getData()
    data.append('file', document.getElementById('file').files[0])
    data.append('x', x)
    data.append('y', y)
    data.append('w', width)
    data.append('h', height)
    this.setState({progress: 0})
    Actions.uploadAvatar({data: data, progress: this.loading, requestSetter: this.requestSetter}).then((res) => {
      this.setState({showCropper: false, progress: false})
      showToastr('success', 'تغییر آواتار', res.data.messages[0])
    }).catch((error) => {
      this.setState({showCropper: false, progress: false})
      showToastr('error', 'تغییر آواتار', error)
    })
  }

  cropMove (e) {
    this.setState({showHelp: false})
  }

  cropEnd (e) {
    this.setState({showHelp: true})
  }

  componentWillReceiveProps (nextProps) {
    this.setState({user: nextProps.user})
  }

  render () {
    const {user, showCropper, progress, showHelp} = this.state
    const tooltipUpdate = (
      <Tooltip id="tooltip">ویرایش تصویر پروفایل</Tooltip>
    )
    const tooltipUpload = (
      <Tooltip id="tooltip">شروع آپلود تصویر</Tooltip>
    )
    const tooltipCancel = (
      <Tooltip id="tooltip">لغو</Tooltip>
    )
    const tooltipHorseShoe = (
      <Tooltip id="tooltip">تعداد نعل‌های کسب شده</Tooltip>
    )
    return (
      <div className={showCropper ? 'UserCover UserCoverCrpper' : 'UserCover'}>
        <Image src={user.avatar.orginal ? user.avatar.orginal : avatar} className="Avatar" />

        {!showCropper && <ButtonToolbar className="EditeAvatar">
          <OverlayTrigger placement="left" overlay={tooltipUpdate}>
            <Button onClick={() => document.getElementById('file').click()}><MdAddAPhoto /></Button>
          </OverlayTrigger>
        </ButtonToolbar>}

        {showCropper && <div className="avatar-cropper-box">
          <Cropper
            style={{ height: 240, width: '100%' }}
            aspectRatio={1 / 1}
            preview=".Avatar"
            guides={false}
            src={this.state.src}
            ref="cropper"
            viewMode={3}
            dragMode="move"
            autoCropArea={1}
            restore={false}
            modal={false}
            highlight={false}
            cropBoxMovable={false}
            cropBoxResizable={false}
            toggleDragModeOnDblclick={false}
            minContainerWidth={240}
            minContainerHeight={240}
            cropmove={this.cropMove}
            cropend={this.cropEnd}
          />

          {(!progress && showHelp) && <div className="help-cropper">
            <p><span>بزرگنمایی</span> <MdMouse /></p>
            <p><span>جابه‌جایی</span> <MdPanTool /></p>
          </div>}

          {progress && <div className="progress-bar" style={{height: 240 - (240 * progress / 100)}} />}

          {!progress && <OverlayTrigger placement="left" overlay={tooltipUpload}>
            <Button onClick={this.startUpload} className="start-upload"><MdFileUpload /></Button>
          </OverlayTrigger>}

          <OverlayTrigger placement="right" overlay={tooltipCancel}>
            <Button onClick={this.cancelUpload} className="cancel-upload"><MdClear /></Button>
          </OverlayTrigger>
        </div>}

        <input id="file" name="file" type="file" className="hide" onChange={this.showCropper} />
        <p className="Username">{user.fullName ? user.fullName : user.username}</p>
        <OverlayTrigger placement="bottom" overlay={tooltipHorseShoe}>
          <Badge><FaMagnet /> {user.point}</Badge>
        </OverlayTrigger>
      </div>
    )
  }
}

UserAvatar.propTypes = {
  user: React.PropTypes.object.isRequired
}
export default UserAvatar



// WEBPACK FOOTER //
// ./src/components/User/UserAvatar.js